import React, { useState, useMemo } from 'react';
import { searchLessons, sortLessonsByNumber } from '../utils/markdownParser';

const PostsListing = ({ lessons, onLessonSelect }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedModule, setSelectedModule] = useState('all');

  const modules = useMemo(() => {
    const moduleSet = new Set();
    lessons.forEach(lesson => {
      const lessonNum = lesson.frontmatter.lessonNumber;
      if (lessonNum) {
        const moduleNum = Math.floor(parseFloat(lessonNum));
        moduleSet.add(moduleNum);
      }
    });
    return Array.from(moduleSet).sort((a, b) => a - b);
  }, [lessons]);

  const filteredLessons = useMemo(() => {
    let filtered = lessons;

    if (searchQuery) {
      filtered = searchLessons(filtered, searchQuery);
    }

    if (selectedModule !== 'all') {
      filtered = filtered.filter(lesson => {
        const lessonNum = lesson.frontmatter.lessonNumber;
        if (!lessonNum) return false;
        const moduleNum = Math.floor(parseFloat(lessonNum));
        return moduleNum === parseInt(selectedModule);
      });
    }

    return sortLessonsByNumber(filtered);
  }, [lessons, searchQuery, selectedModule]);

  const groupedLessons = useMemo(() => {
    const groups = {};
    filteredLessons.forEach(lesson => {
      const lessonNum = lesson.frontmatter.lessonNumber;
      if (lessonNum) {
        const moduleNum = Math.floor(parseFloat(lessonNum));
        if (!groups[moduleNum]) {
          groups[moduleNum] = [];
        }
        groups[moduleNum].push(lesson);
      }
    });
    return groups;
  }, [filteredLessons]);

  return (
    <div className="posts-listing">
      <header className="listing-header">
        <h1>AI Solution Architect Training</h1>
        <p>Comprehensive training program for Data & Integration Solution Architects</p>
      </header>

      <div className="filters">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search lessons..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>

        <div className="module-filter">
          <select
            value={selectedModule}
            onChange={(e) => setSelectedModule(e.target.value)}
            className="module-select"
          >
            <option value="all">All Modules</option>
            {modules.map(module => (
              <option key={module} value={module}>
                Module {module}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="lessons-grid">
        {Object.entries(groupedLessons).map(([moduleNum, moduleLessons]) => (
          <div key={moduleNum} className="module-section">
            <h2 className="module-title">Module {moduleNum}</h2>
            <div className="lessons-list">
              {moduleLessons.map(lesson => (
                <div
                  key={lesson.frontmatter.slug}
                  className="lesson-card"
                  onClick={() => onLessonSelect(lesson.frontmatter.slug)}
                >
                  <div className="lesson-number">
                    Lesson {lesson.frontmatter.lessonNumber}
                  </div>
                  <h3 className="lesson-title">
                    {lesson.frontmatter.title?.replace(/^Lesson \d+\.\d+:\s*/, '')}
                  </h3>
                  <div className="lesson-preview">
                    {lesson.content.substring(0, 150)}...
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {filteredLessons.length === 0 && (
        <div className="no-results">
          <p>No lessons found matching your search criteria.</p>
          <button
            onClick={() => {
              setSearchQuery('');
              setSelectedModule('all');
            }}
            className="clear-filters-button"
          >
            Clear Filters
          </button>
        </div>
      )}
    </div>
  );
};

export default PostsListing;